// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1zWNX","question":"Question_question__1fVGw","description":"Question_description__2M0Nc"};